import gql from "graphql-tag";

export default gql`
  mutation VerifyUserEmailAndSetPassword($id: ID!, $password: String!) {
    verifyInvitedUser(userId: $id, password: $password) {
      verifiedInvitedUser
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/VerifyUserEmailAndSetPassword.ts